import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var UserCircle = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M12 2C6.579 2 2 6.579 2 12s4.579 10 10 10 10-4.579 10-10S17.421 2 12 2zm0 18c-2.151 0-4.135-.902-5.59-2.34.753-1.807 2.515-3.088 4.59-3.088h2c2.075 0 3.837 1.281 4.59 3.088C16.135 19.098 14.151 20 12 20zm0-13c1.727 0 3 1.272 3 3s-1.273 3-3 3c-1.726 0-3-1.272-3-3s1.274-3 3-3z", key: "k0" })));
});
UserCircle.displayName = 'UserCircle';
export var UserCircleDimensions = { height: 24, width: 24 };
